import React from 'react';
import ValidationElement from '../ValidationElement';
import Radio from '../Radio';
import RadioGroup from '../RadioGroup';

export default class MaidenName extends ValidationElement {
  constructor(props) {
    super(props);

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  /**
   * Handle the change event.
   */
  handleUpdate(values) {
    this.props.onUpdate({
      name: this.props.name,
      value: values.value,
    });
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `maiden.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  render() {
    const klass = `maiden-name ${this.props.className || ''}`.trim();

    return (
      <div className={klass}>
        <label id="maidenname">{this.props.label}</label>
        <RadioGroup
          attribute={this.props.attribute}
          className="option-list"
          selectedValue={this.props.value}
          onError={this.props.onError}
          required={this.props.required}
        >
          <Radio
            name="maiden-name"
            label="Yes"
            value="Yes"
            className="yes"
            disabled={this.props.disabled}
            readonly={this.props.readonly}
            required={this.props.required}
            onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          />
          <Radio
            name="maiden-name"
            label="No"
            value="No"
            className="no"
            disabled={this.props.disabled}
            readonly={this.props.readonly}
            required={this.props.required}
            onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          />
        </RadioGroup>
      </div>
    );
  }
}

MaidenName.defaultProps = {
  value: '',
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
};

MaidenName.errors = [];
